import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { signInSso } from '../../modules/auth.js';
import { saveOktaConfig } from '../../lib/oktaConfig.js';

const AuthCallback = ({ signInSso }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const processOktaCallback = async () => {
      try {
        if (typeof window === 'undefined' || !window.OktaAuth) {
          throw new Error('Okta not available');
        }

        const urlParams = new URLSearchParams(window.location.search);
        const authCode = urlParams.get('code');
        const stateParam = urlParams.get('state');

        if (!authCode) {
          throw new Error('Authentication failed');
        }

        let ssoConfig = null;

        if (stateParam) {
          try {
            ssoConfig = JSON.parse(atob(stateParam));
          } catch (e) {
            throw new Error('Authentication failed');
          }
        } else {
          throw new Error('Authentication failed');
        }

        const oktaAuth = new window.OktaAuth({
          issuer: ssoConfig.issuer,
          clientId: ssoConfig.clientId,
          redirectUri: `${window.location.origin}/login/callback`,
          postLogoutRedirectUri: `${window.location.origin}/logout/callback`,
          scopes: ['openid', 'profile', 'email'],
          pkce: true,
          responseType: 'code',
          tokenManager: {
            autoRenew: false,
          },
        });

        try {
          const tokens = await oktaAuth.token.parseFromUrl();
          let accessToken = null;
          let idToken = null;

          if (tokens?.tokens?.accessToken) {
            accessToken =
              tokens.tokens.accessToken.accessToken ||
              tokens.tokens.accessToken.value;

            await oktaAuth.tokenManager.setTokens(tokens.tokens);
          }

          if (tokens?.tokens?.idToken) {
            idToken =
              tokens.tokens.idToken.idToken || tokens.tokens.idToken.value;
          }

          if (!accessToken) {
            throw new Error('Authentication failed');
          }

          saveOktaConfig({
            issuer: ssoConfig.issuer,
            clientId: ssoConfig.clientId,
            redirectUri: `${window.location.origin}/login/callback`,
            postLogoutRedirectUri: `${window.location.origin}/logout/callback`,
            scopes: ['openid', 'profile', 'email'],
          });

          await signInSso(accessToken, idToken);
          const returnUrl = localStorage.getItem('sso_return_url') || '/';
          localStorage.removeItem('sso_return_url');
          window.location.replace(returnUrl);
        } catch (err) {
          console.error('OAuth callback error:', err);
          setError(`Authentication failed: ${err.message}`);
          setLoading(false);
        }
      } catch (err) {
        console.error('OAuth callback error:', err);
        setError(`Authentication failed: ${err.message}`);
        setLoading(false);
      }
    };

    processOktaCallback();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}
      >
        <div>Processing authentication...</div>
        <div style={{ marginTop: '20px' }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}
      >
        <div style={{ color: 'red', marginBottom: '20px' }}>{error}</div>
      </div>
    );
  }

  return null;
};

export default connect(null, { signInSso })(AuthCallback);
